/**
 * 「最近見た商品」（#44）
 *
 * 商品詳細ページを開いたときに handle を localStorage へ保存し、履歴のうち
 * 現在の商品を除いた最大4件を新しい順に描画する。保存するのは handle の配列だけで、
 * 価格・在庫・個人情報は保存しない。
 *
 * カードのマークアップはサーバー側が <template data-recently-viewed-card> として
 * 書き出しているものをクローンする。テンプレートが無い handle（非公開・削除済み）は
 * 描画対象から外れるため、クリックして404になることが無い。
 *
 * テーマエディタで設定を変えるとセクションが再描画され、この <section> も作り直される。
 * 読み込み時に1回描画するだけだと、再描画後はプレースホルダだけが残って実カードが消えるため、
 * shopify:section:load で描画し直す（#81 (3)）。
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'stilllife:recently-viewed';
  var MAX_STORED = 8;
  var MAX_SHOWN = 4;
  /* handle は Shopify 側で 255 文字を超えないため、これより長い値は壊れた保存とみなす */
  var MAX_HANDLE_LENGTH = 255;

  function isValidHandle(handle) {
    return (
      typeof handle === 'string' &&
      handle !== '' &&
      handle.length <= MAX_HANDLE_LENGTH
    );
  }

  // プライベートブラウズなど localStorage が使えない環境では例外が出る。
  // 履歴が無いものとして扱い、他の表示は壊さない。
  // 保存上限を超える配列が入っていても（古い版の保存・手で書き換えた値）、
  // 読み込み時に MAX_STORED に切り詰めてから使う（#81 (2)）
  function readHistory() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return parsed.slice(0, MAX_STORED).filter(isValidHandle);
    } catch (error) {
      return [];
    }
  }

  function writeHistory(handles) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    } catch (error) {
      /* 保存できなくても表示は続ける */
    }
  }

  function render(root) {
    var currentHandle = root.getAttribute('data-current-handle') || '';
    var list = root.querySelector('[data-recently-viewed-list]');
    if (!list) return;

    var viewed = readHistory();

    // handle → <template> の対応表を作る。属性セレクタを文字列連結して
    // querySelector に渡すと、壊れた値が入っていたときに SyntaxError になる。
    // handle は 'constructor' や 'toString' も取り得るため、プロトタイプを持たない
    // オブジェクトにする（{} だと継承したプロパティを <template> と誤認する）
    var templates = Object.create(null);
    Array.prototype.forEach.call(
      root.parentNode.querySelectorAll('[data-recently-viewed-card]'),
      function (template) {
        var handle = template.dataset ? template.dataset.handle : template.getAttribute('data-handle');
        if (handle) templates[handle] = template;
      }
    );

    // 候補が50件で頭打ちになっている（Liquid 側の上限）ときは気づけるようにする。
    // 出すのはテーマエディタだけ。公開画面の console に運用メモを残さない（#81 (4)）
    if (root.hasAttribute('data-candidates-truncated') && window.Shopify && window.Shopify.designMode) {
      // eslint-disable-next-line no-console
      console.warn('[stilllife] 最近見た商品の候補が50件で打ち切られています。');
    }

    // 表示に使うのは「保存する前」の履歴。現在の商品を先頭へ積むのは保存だけで、
    // 一覧には現在の商品を出さない。
    var stored = [currentHandle]
      .concat(viewed)
      .filter(function (handle, index, all) {
        return isValidHandle(handle) && all.indexOf(handle) === index;
      })
      .slice(0, MAX_STORED);

    if (currentHandle !== '') writeHistory(stored);

    var fragment = document.createDocumentFragment();
    var shown = 0;

    viewed.forEach(function (handle) {
      if (shown >= MAX_SHOWN || handle === currentHandle) return;

      var template = templates[handle];
      if (!template) return;

      fragment.appendChild(template.content.cloneNode(true));
      shown += 1;
    });

    if (shown === 0) return;

    // テーマエディタではプレビュー用のプレースホルダが先に入っている。
    // 実カードを足す前に取り除かないと、両方が並んでしまう。
    // 同じ要素に対して2回目の描画が走っても重複しないよう、既存の子を全て外してから足す
    while (list.firstChild) list.removeChild(list.firstChild);

    list.appendChild(fragment);
    root.hidden = false;
  }

  var root = document.querySelector('[data-recently-viewed]');
  if (root) render(root);

  // テーマエディタのセクション再描画。イベントの target は再描画されたセクション要素
  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target;
    if (!target || !target.querySelector) return;
    var reloaded = target.querySelector('[data-recently-viewed]');
    if (reloaded) render(reloaded);
  });
})();
